import React from 'react';
import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogContent,
  DialogActions,
  Button,
  Input,
  Field,
  DialogTrigger,
} from '@fluentui/react-components';
import { Dismiss20Regular } from '@fluentui/react-icons';

interface ReportSettingsDialogProps {
  open: boolean;
  onOpenChange: (event: any, data: { open: boolean }) => void;
  onSave: (reportData: {
    incidentName: string;
    reportName: string;
    executiveSummary: string;
    participatingOrganizations: string;
  }) => void;

  initialData?: {
    incidentName?: string;
    reportName?: string;
    executiveSummary?: string;
    participatingOrganizations?: string;
  };
  title: string;
}

export const ReportSettingsDialog: React.FC<ReportSettingsDialogProps> = ({
  open,
  onOpenChange,
  onSave,
  initialData,
  title,
}) => {
  const [incidentName, setIncidentName] = React.useState(initialData?.incidentName || '');
  const [reportName, setReportName] = React.useState(initialData?.reportName || '');
  const [executiveSummary, setExecutiveSummary] = React.useState(initialData?.executiveSummary || '');
  const [participatingOrganizations, setParticipatingOrganizations] = React.useState(
    initialData?.participatingOrganizations || ''
  );

  React.useEffect(() => {
    if (initialData) {
      setIncidentName(initialData.incidentName || '');
      setReportName(initialData.reportName || '');
      setExecutiveSummary(initialData.executiveSummary || '');
      setParticipatingOrganizations(initialData.participatingOrganizations || '');
    } else {
      setIncidentName('');
      setReportName('');
      setExecutiveSummary('');
      setParticipatingOrganizations('');
    }
  }, [initialData]);

  const handleSave = () => {
    onSave({
      incidentName,
      reportName,
      executiveSummary,
      participatingOrganizations,
    });
    onOpenChange?.(undefined, { open: false });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <DialogTrigger action="close">
                <Button appearance="subtle" icon={<Dismiss20Regular />} />
              </DialogTrigger>
            }
          >
            {title}
          </DialogTitle>
          <DialogContent>
            <form>
              <Field label="Incident Name" required>
                <Input
                  value={incidentName}
                  readOnly
                  placeholder="Incident Name (read-only)"
                />
              </Field>

              <Field label="Name of the Report" required>
                <Input
                  value={reportName}
                  onChange={(e, data) => setReportName(data.value)}
                  placeholder="Enter the report name"
                />
              </Field>
              <Field label="Executive Summary">
                <Input
                  value={executiveSummary}
                  onChange={(e, data) => setExecutiveSummary(data.value)}
                  placeholder="Short summary of the report"
                />
              </Field>
              <Field label="Participating Organizations">
                <Input
                  value={participatingOrganizations}
                  onChange={(e, data) => setParticipatingOrganizations(data.value)}
                  placeholder="Organizations involved"
                />
              </Field>
            </form>
          </DialogContent>
          <DialogActions>
            <Button
              appearance="primary"
              onClick={handleSave}
              disabled={!reportName.trim()}
            >
              Save
            </Button>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">Cancel</Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
